import { isValidPhoneNumber } from "libphonenumber-js";

// crypto instead of Math.random: a static code stays valid forever, so it must not be predictable
export const generateOtpCode = () =>
  Array.from(window.crypto.getRandomValues(new Uint32Array(6)), (value) => value % 10).join("");

// Same check as the next-app login form, so a phone accepted here can actually log in there
export const isValidOtpPhone = (phoneDigits: string) => isValidPhoneNumber(`+${phoneDigits}`);
